import React from 'react';

import { Divider, Link, TitleWithDescription, Chip } from '@infoods/lifebase-ui';

import classes from './SuccessfulResult.module.scss';
import { ChallengePaymentResult } from '../../../../interfaces/paymentResult';
import { ResultTitle } from '../../../../components/payment-result/ResultTitle/ResultTitle';
import { PaymentDetails } from '../../../../components/payment-result/PaymentDetails/PaymentDetails';
import { ContactCard } from '../../../../../shared/components/ContactCard/ContactCard';
import { NutritionRegistrationBlock } from '../../../../../challenges';

type SuccessfulResultProps = {
  paymentInfo: ChallengePaymentResult;
};

const SuccessfulResult = ({ paymentInfo }: SuccessfulResultProps) => {
  const isHaveExtraInfo =
    paymentInfo.coachContact ||
    paymentInfo.nutritionRegistrationUrl ||
    paymentInfo.entityContact;

  return (
    <div className={classes.container}>
      <div className={classes.paymentInfo}>
        <ResultTitle isSuccessful title="Payment Complete" />
        <PaymentDetails paymentInfo={paymentInfo.paymentDetails} />
      </div>
      {isHaveExtraInfo && (
        <>
          <Divider />
          {paymentInfo.coachContact && (
            <div className={classes.additionalInfo}>
              <Chip
                className={classes.chip}
                size="small"
                color="primary"
                label="Upgrade to work with your nutrition coach"
              />
              <TitleWithDescription
                title="Contact Your Coach to Reactivate Your Nutrition Subscription"
                titleFont="title-18-bold"
                description="Participants working with a coach lose more body fat than those doing challenges alone"
              />
              <ContactCard
                title="Your coach"
                name={`${paymentInfo.coachContact?.firstName} ${paymentInfo.coachContact?.lastName}`}
                {...paymentInfo.coachContact}
              />
            </div>
          )}
          {paymentInfo.nutritionRegistrationUrl && (
            <div className={classes.additionalInfo}>
              <TitleWithDescription
                title="Get Personalized Guidance from a Nutrition Coach "
                titleFont="title-18-bold"
                description={
                  <p>
                    <span className={classes.darkText}>
                      Boost your performance — 99% of participants
                    </span>
                    &nbsp;succeed.
                    <br />
                    (incl. additional fees.)
                  </p>
                }
              />
              <NutritionRegistrationBlock
                nutritionRegistrationUrl={paymentInfo.nutritionRegistrationUrl}
              />
            </div>
          )}
          {paymentInfo.entityContact && (
            <div className={classes.additionalInfo}>
              <TitleWithDescription
                title="Contact to Create Your Nutrition Subscription"
                titleFont="title-18-bold"
                description="Before creating an account, please contact us to discuss the terms of cooperation."
              />
              <ContactCard
                title="Contact"
                name={paymentInfo.entityContact.entityName}
                email={paymentInfo.entityContact.adminEmail}
                phone={paymentInfo.entityContact.adminPhone}
                avatar={paymentInfo.entityContact.adminAvatar}
              />
            </div>
          )}
          <p className={classes.helpText}>
            <span>Need help?</span> Email our support team at&nbsp;
            <Link href={`mailto:${paymentInfo.entityEmail}`}>
              {paymentInfo.entityEmail}
            </Link>
          </p>
        </>
      )}
    </div>
  );
};

export { SuccessfulResult };
